import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { CelebrationOverlay } from '../components/common/CelebrationOverlay';

interface CelebrationContextType {
  triggerCelebration: () => void;
}

const CelebrationContext = createContext<CelebrationContextType | undefined>(undefined);

export const useCelebration = () => {
  const context = useContext(CelebrationContext);
  if (!context) {
    throw new Error('useCelebration must be used within CelebrationProvider');
  }
  return context;
};

interface CelebrationProviderProps {
  children: ReactNode;
}

export const CelebrationProvider: React.FC<CelebrationProviderProps> = ({ children }) => {
  const [showCelebration, setShowCelebration] = useState(false);

  useEffect(() => {
    const handleCelebration = (event: Event) => {
      console.log('[CelebrationProvider] Task celebration event received!', event);
      setShowCelebration(true);
    };

    console.log('[CelebrationProvider] Adding taskCelebration event listener');
    window.addEventListener('taskCelebration', handleCelebration);
    
    return () => {
      console.log('[CelebrationProvider] Removing taskCelebration event listener');
      window.removeEventListener('taskCelebration', handleCelebration);
    };
  }, []);

  const triggerCelebration = () => {
    console.log('[CelebrationProvider] Manual trigger');
    setShowCelebration(true);
  };

  return (
    <CelebrationContext.Provider value={{ triggerCelebration }}>
      {children}
      <CelebrationOverlay 
        show={showCelebration} 
        onComplete={() => {
          console.log('[CelebrationProvider] Celebration complete, hiding');
          setShowCelebration(false);
        }} 
      />
    </CelebrationContext.Provider>
  );
};
